import type { ReactNode } from 'react';
import { cn } from './cn';

interface DataListProps {
  children: ReactNode;
  view: string;
  className?: string;
}

export const DataList = ({ children, view, className }: DataListProps) => (
  <div
    className={cn(
      view === 'list'
        ? 'my-6 min-w-[800px] overflow-hidden border-y border-border/35'
        : 'mb-12 mt-6 flex-wrap gap-6 md:gap-8',
      'flex items-start relative flex-wrap w-full',
      className
    )}
  >
    {children}
  </div>
);

interface DataListHeaderProps {
  children: ReactNode;
}

export const DataListHeader = ({ children }: DataListHeaderProps) => (
  <div className="flex w-full border-b border-border/35 bg-white/45">{children}</div>
);

interface DataListHeaderCellProps {
  children?: ReactNode;
  className?: string;
}

export const DataListHeaderCell = ({ children, className }: DataListHeaderCellProps) => (
  <div className={cn('flex-shrink-0 border-r border-border/25 px-6 py-3.5', className)}>
    {children && (
      <p className="text-[11px] font-semibold uppercase text-muted md:text-xs">
        {children}
      </p>
    )}
  </div>
);
